import React, { useState, useEffect, useCallback } from "react";
import { Grid, Container, Typography, Box } from "@mui/material";
import api from "../../globals/axios";
import { useParams } from "react-router-dom";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import {
  CustomLabel,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import { useTranslation } from "react-i18next";
import { acresToHectares } from "../../globals/utils";
import AMSatelliteDataViewer from "../../components/SatelliteCharts/AMSatelliteDataViewer";

const ViewFarmSatelliteData = () => {
  const { t } = useTranslation();
  const { farmId } = useParams();
  const [loading, setLoading] = useState(true);
  const [farmData, setFarmData] = useState({
    farm_name: "",
    area: "",
    regulator: "",
    pin_code: "",
    irrigation_source: [],
    irrigation_system: [],
    soil_texture: [],
    crops: [],
  });

  const labelValuePairs = [
    { label: t("Farm Name"), value: farmData.farm_name },
    {
      label: t("Area"),
      value: `${farmData.area} ${t("acres")} (${acresToHectares(
        farmData.area
      )} ${t("hectares")})`,
    },
    {
      label: t("Irrigation Source"),
      value:
        farmData.irrigation_source.map((source) => source.name).join(", ") ||
        "N/A",
    },
    {
      label: t("Irrigation System"),
      value:
        farmData.irrigation_system.map((system) => system.name).join(", ") ||
        "N/A",
    },
    {
      label: t("Soil Texture"),
      value: farmData.soil_texture[0]?.name ?? "N/A",
    },
  ];

  const loadFarmData = useCallback(async () => {
    try {
      const res = await api.get(`/farmer/farms/${farmId}`);
      setFarmData(res.data);
    } catch (error) {
      console.error("Error loading farm data:", error);
    }
  }, [farmId]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([loadFarmData()]);
      setLoading(false);
    };
    fetchData();
  }, [farmId, loadFarmData]);

  return (
    <>
      <CustomAppBar isProtected={false} />
      <LoaderContainer loading={loading}>
        <Box sx={{ textAlign: "center", my: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {t("Farm Satellite Data")}
          </Typography>
        </Box>
        <Container maxWidth="xs" sx={{ padding: "0px 16px" }}>
          <Box
            sx={{
              backgroundColor: "#fff",
            }}
            borderRadius={2}
            boxShadow={2}
            padding={2}
          >
            <Grid container direction="column" style={{ marginTop: "10px" }}>
              {labelValuePairs.map((pair) => (
                <Grid item container key={pair.label}>
                  <Grid item xs={5}>
                    <CustomLabel>{pair.label}</CustomLabel>
                  </Grid>
                  <Grid item xs={1}>
                    <CustomLabel>:</CustomLabel>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomValue>{pair.value}</CustomValue>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* <SatelliteDataViewer farmId={farmId} polygon={farmData.polygon} /> */}
          <AMSatelliteDataViewer farmId={farmId} polygon={farmData.polygon} />
        </Container>
      </LoaderContainer>
    </>
  );
};

export default ViewFarmSatelliteData;
